export default "__VITE_ASSET__DSIRNFJ9__"